const BASE_URL =
  `${window.location.protocol}//${window.location.hostname}` +
  (window.location.hostname === "localhost" ? ":3000" : "");

const WEBAPI_ENDPOINT = window.location.hostname === "localhost" ? "http://localhost:8080" : "";

const CAAS_ENVIRONMENT = process.env.REACT_APP_CAAS_ENVIRONMENT ?? "";
/**
 * アプリーケーションの環境設定インタフェースです。
 */
export interface AppEnv {
  /** クライアントID */
  clientId: string;
  /** ベースURL */
  baseUrl: string;
  /** アカウントURL */
  accountsUrl: string;
  /** 認証URL */
  authUrl: string;
  /** APIのエンドポイント */
  webApiEndPoint: string;
}

const DEFAULT_APP_ENV: AppEnv = {
  clientId: "",
  baseUrl: BASE_URL,
  accountsUrl: "",
  authUrl: "",
  webApiEndPoint: WEBAPI_ENDPOINT,
};

const DEVU_APP_ENV: AppEnv = {
  ...DEFAULT_APP_ENV,
  clientId: "70dgwtftQ7tNSE7iUy95hXaterUS0LZU",
  accountsUrl: "https://devu.accounts.ricoh.com",
  authUrl: "https://api.devu.smart-integration.ricoh.com",
};

const DEVE_APP_ENV: AppEnv = {
  ...DEFAULT_APP_ENV,
  clientId: "70qgFZ8TBBIKk994KbadOI7hqg5l5W39",
  accountsUrl: "https://deve.accounts.ricoh.com",
  authUrl: "https://api.deve.smart-integration.ricoh.com",
};

const NA_APP_ENV: AppEnv = {
  ...DEFAULT_APP_ENV,
  clientId: "70G5y40mxkObcSDSUChrdW0ChDUzZQ45",
  accountsUrl: "https://na.accounts.ricoh.com",
  authUrl: "https://api.na.smart-integration.ricoh.com",
};

const EU_APP_ENV: AppEnv = {
  ...DEFAULT_APP_ENV,
  clientId: "70txWfLyO0YYdcnRYpaqe6gC6tHgOjWc",
  accountsUrl: "https://eu.accounts.ricoh.com",
  authUrl: "https://api.eu.smart-integration.ricoh.com",
};

/**
 * アプリケーション環境設定を取得します。
 * @returns アプリケーション環境設定
 */
export const getAppEnv = (): AppEnv => {
  switch (CAAS_ENVIRONMENT) {
    case "devu":
      return DEVU_APP_ENV;
    case "deve":
      return DEVE_APP_ENV;
    case "na":
      return NA_APP_ENV;
    case "eu":
      return EU_APP_ENV;
    default:
      return DEFAULT_APP_ENV;
  }
};
